'use client';

import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { copyFontSizeSmall, token } from '@nib-components/theme';
import { Box, py, px, breakpoint } from '@nib/layout';
// Prop types
export const validVariationValues = ['default', 'prominent', 'gentle', 'muted', 'brand', 'success', 'info', 'warning', 'error'];
const validSizeValues = ['small', 'default'];
export const pickBackgroundColor = variation => {
  switch (variation) {
    case 'default':
    default:
      return 'var(--tagColorBg,#ffffff)';
    case 'brand':
      return 'var(--tagColorBgBrand,#636363)';
    case 'info':
      return 'var(--tagColorBgInfo,#005bb9)';
    case 'error':
      return 'var(--tagColorBgError,#c81414)';
    case 'success':
      return 'var(--tagColorBgSuccess,#007800)';
    case 'warning':
      return 'var(--tagColorBgWarning,#ffb400)';
    case 'prominent':
      return 'var(--tagColorBgProminent,#111111)';
    case 'gentle':
      return 'var(--tagColorBgGentle,#484848)';
    case 'muted':
      return 'var(--tagColorBgMuted,#6A6A6A)';
  }
};
export const pickForeground = variation => {
  // Fallbacks here are not trying to match the CSS vars.
  // They are to pair with the brighter old colours above.
  switch (variation) {
    case 'default':
    default:
      return 'var(--tagColorFg,inherit)';
    case 'brand':
      return 'var(--tagColorFgBrand,#ffffff)';
    case 'info':
      return 'var(--tagColorFgInfo,#ffffff)';
    case 'error':
      return 'var(--tagColorFgError,#ffffff)';
    case 'success':
      return 'var(--tagColorFgSuccess,#ffffff)';
    case 'warning':
      return 'var(--tagColorFgWarning,inherit)';
    case 'prominent':
      return 'var(--tagColorFgProminent,#ffffff)';
    case 'gentle':
      return 'var(--tagColorFgGentle,#ffffff)';
    case 'muted':
      return 'var(--tagColorFgMuted,#ffffff)';
  }
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Wrapper = styled(_ref => {
  let {
    variation,
    size,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    ...rest
  });
})`
  display: inline-block;
  white-space: nowrap;
  word-break: break-word;
  hyphens: auto;

  font-size: ${token(`tag.typography.fontSize`, copyFontSizeSmall)};
  font-family: ${token(`tag.typography.fontFamily`)};
  line-height: ${token(`tag.typography.lineHeight`)};
  letter-spacing: ${token(`tag.typography.letterSpacing`)};
  text-transform: ${token(`tag.typography.textTransform`)};
  font-weight: ${token(`tag.typography.fontWeight`, 400)};
  border-radius: ${token(`theme.dimension.border.radius.small`, '0.25rem')};

  ${breakpoint('mini')`
    hyphens: none;  
  `}

  ${_ref2 => {
  let {
    variation
  } = _ref2;
  return variation && css`
      background-color: ${pickBackgroundColor(variation)};
      color: ${pickForeground(variation)};
    `;
}}

  ${_ref3 => {
  let {
    size
  } = _ref3;
  return size === 'default' ? css`
          ${py(1)};
          ${px(2)};
        ` : css`
          padding-block: 0.125rem;
          ${px(1)};
        `;
}};
`;
const Tag = props => {
  const {
    variation,
    size = 'default',
    children,
    background,
    foreground,
    ...otherProps
  } = props;
  return /*#__PURE__*/_jsx(Wrapper, {
    variation: variation,
    size: size,
    background: background,
    color: foreground,
    ...otherProps,
    "data-mesh-component": "TAG",
    children: children
  });
};
Tag.displayName = 'Tag';
export default Tag;